// Placeholder selected-work cases — all under NDA, anonymised on purpose.
const work = [
  {
    code: "CASE 0x01",
    sector: "Financial Services",
    title: "Brokerage platform migration from legacy COBOL to a hybrid cloud architecture.",
    year: "2024 — 2025",
    span: "14 months",
    state: "shipped",
    services: ["Software", "Cloud & DevOps", "Security"]
  },
  {
    code: "CASE 0x02",
    sector: "Digital Markets",
    title: "Custom CRM + order-routing rebuild for a multi-asset trading venue.",
    year: "2025",
    span: "9 months",
    state: "shipped",
    services: ["CRM", "Software", "Data & BI"]
  },
  {
    code: "CASE 0x03",
    sector: "Logistics & Trade",
    title: "Multi-site SD-WAN, factory-floor Wi-Fi 6E rollout and edge compute.",
    year: "2024",
    span: "6 months",
    state: "shipped",
    services: ["Network", "Managed IT"]
  },
  {
    code: "CASE 0x04",
    sector: "Healthcare",
    title: "Patient-data platform with KVKK/GDPR-aligned audit logging and access.",
    year: "2025",
    span: "ongoing",
    state: "in-flight",
    services: ["Data & BI", "Security", "Software"]
  },
  {
    code: "CASE 0x05",
    sector: "Retail & E-commerce",
    title: "Unified-customer-view data warehouse and dashboarding for an apparel group.",
    year: "2024",
    span: "5 months",
    state: "shipped",
    services: ["Data & BI", "Advisory"]
  },
  {
    code: "CASE 0x06",
    sector: "Manufacturing",
    title: "OT/IT segmentation, MES integration and 24/7 NOC for three production sites.",
    year: "2023 — 2025",
    span: "retainer",
    state: "operating",
    services: ["Network", "Security", "Managed IT"]
  }
];

export default work;
